export const routes = (parentName) => {
  return [
    {
      path: 'events',
      component: () => import('./Index.vue'),
      children: [
        {
          path: '',
          name: `${parentName}-Events`,
          component: () => import('./List.vue'),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: 'new',
          name: `${parentName}-Events-New`,
          component: () => import('./Upsert.vue'),
        },
        {
          path: ':id',
          name: parentName + '-' + 'Events-View',
          component: () => import('./View.vue'),
        },
        {
          path: ':id/edit',
          name: parentName + '-' + 'Events-Edit',
          component: () => import('./Upsert.vue'),
        },
      ],
    },
  ];
};
